import React, { useEffect, useState } from "react";

import Window from "../../../../elements/window";

import Slide1 from "./slides/slide1";

import Loader from "../../../../../settings/loader";

function SessionSummary(props) {
  const [sales, setSales] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        if (props?.user?.data) {
          await fetchData();
        }
      } catch (err) {
        console.log("Error occured when fetching");
      }
    })();
  }, []);

  const fetchData = async () => {
    const getSales = await fetch(props.chimeraserv.urlGet + "/by-session-v2/", {
      method: "POST",
      body: JSON.stringify({ base64: props.filter.base64 }),
      headers: {
        Authorization: props.user.data.usrKey,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const jsonRes = await getSales.json();

    const chains = props?.filter?.data?.chains;

    const withNames = jsonRes?.map((item) => {
      return {
        ...item,
        currency: `${chains
          ?.find((chainItem) => chainItem?.chaKey == item?.chaKey)
          ?.currency?.toUpperCase()}`,
        restaurant_name: `${
          chains?.find((chainItem) => chainItem?.chaKey == item?.chaKey)?.name
        }`,
      };
    });

    await setSales(withNames);
  };

  return sales ? (
    <div className={["contentContainer"]}>
      <div className={["contentRow"]} style={{ width: "100%" }}>
        <Window
          user={props.user}
          chimeraserv={props.chimeraserv}
          title={"Opend and Closed sessions"}
          horizontal
        >
          <Slide1
            {...props}
            slideData={JSON.parse(JSON.stringify(sales))}
            //striginfy to store as value not as reference so no original array changes when modify the copy
          />
        </Window>
      </div>
    </div>
  ) : (
    <Loader />
  );
}

export default SessionSummary;
